import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import Constants from './Constants';

class ViewerStore extends ReduceStore {
  constructor() {
    super(Dispatcher);

    this.onMessage = this.onMessage.bind(this);
  }

  getInitialState() {
    return {
      isReady: false,
      reference: null,
      code: null,
    }
  }

  onMessage(event) {
    // We need to know when the viewer is ready, to dispatch an event.
    if ( ! (event && event.data && event.data.action === 'onStateChange' && event.data.state.viewerState == 'loaded')) {
      return
    }

    window.removeEventListener('message', this.onMessage, false);

    Dispatcher.dispatch({
      actionType: Constants.APP_VIEWER_DID_LOAD
    });
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.APP_LOAD_PRODUCT_IN_VIEWER:
        return { ...state, isReady: false, code: action.code };

      case Constants.APP_SET_VIEWER_REFERENCE:
        window.addEventListener('message', this.onMessage, false);
        return { ...state, isReady: false, reference: action.reference };

      case Constants.APP_VIEWER_DID_LOAD:
        return { ...state, isReady: true };

      default:
        return state;
    }
  }
}

export default new ViewerStore();



// WEBPACK FOOTER //
// ./src/flux/ViewerStore.js